import { useMemo } from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Cell } from "recharts";

const startOfWeek = (d) => {
  const x = new Date(d);
  const day = (x.getDay() + 6) % 7; // Monday = 0
  x.setHours(0, 0, 0, 0);
  x.setDate(x.getDate() - day);
  return x;
};

const WEEKS = 8;

export const EnquiryTrends = ({ enquiries }) => {
  const { data, total, peak } = useMemo(() => {
    const now = startOfWeek(new Date());
    const buckets = [];
    for (let i = WEEKS - 1; i >= 0; i--) {
      const s = new Date(now);
      s.setDate(s.getDate() - i * 7);
      buckets.push({ ts: s.getTime(), week: s.toLocaleDateString("en-AU", { day: "2-digit", month: "short" }), enquiries: 0 });
    }
    enquiries.forEach((e) => {
      const t = new Date(e.created_at);
      if (isNaN(t)) return;
      const ws = startOfWeek(t).getTime();
      const b = buckets.find((x) => x.ts === ws);
      if (b) b.enquiries += 1;
    });
    return {
      data: buckets,
      total: buckets.reduce((a, b) => a + b.enquiries, 0),
      peak: Math.max(0, ...buckets.map((b) => b.enquiries)),
    };
  }, [enquiries]);

  return (
    <section className="mt-10 border border-black/10 bg-white px-6 md:px-8 py-6" data-testid="admin-trends">
      <div className="flex flex-wrap items-baseline justify-between gap-2">
        <div>
          <p className="text-[10px] uppercase tracking-[0.25em] text-[#4A524D]">Enquiries per week</p>
          <h2 className="mt-1 font-serif text-2xl tracking-tight text-[#111413]">Lead trend — last {WEEKS} weeks</h2>
        </div>
        <p className="text-xs text-[#4A524D]" data-testid="admin-trends-summary">
          {total} enquir{total === 1 ? "y" : "ies"} · peak {peak}/week
        </p>
      </div>
      <div className="mt-6 h-56 w-full" data-testid="admin-trends-chart">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 8, right: 8, left: -20, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="rgba(10,35,51,0.08)" vertical={false} />
            <XAxis dataKey="week" tick={{ fontSize: 11, fill: "#4A524D" }} tickLine={false} axisLine={{ stroke: "rgba(10,35,51,0.15)" }} />
            <YAxis allowDecimals={false} tick={{ fontSize: 11, fill: "#4A524D" }} tickLine={false} axisLine={false} width={40} />
            <Tooltip
              cursor={{ fill: "rgba(10,35,51,0.05)" }}
              contentStyle={{ border: "1px solid rgba(10,35,51,0.15)", borderRadius: 0, fontSize: 12 }}
              labelFormatter={(l) => `Week of ${l}`}
              formatter={(v) => [v, "Enquiries"]}
            />
            <Bar dataKey="enquiries" radius={[2, 2, 0, 0]} maxBarSize={48}>
              {data.map((d, i) => (
                <Cell key={d.week} fill={i === data.length - 1 ? "#A78558" : "#0A2333"} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </section>
  );
};
